// @flow
import React from 'react'
import { createComponent } from 'react-fela'

import LazyImage from 'design-framework/atoms/LazyImage'
import { noArtistImageUrl } from 'design-framework/common/config'
import Typography from 'design-framework/atoms/Typography'
import Edit from 'design-framework/common/icons/edit.svg'
import {
	__artist,
	__artistImg,
	__artistInfo,
	ImageIconWrapper,
	IconWrapper,
	ArtistIcon,
} from './__style'

const Artist = createComponent(__artist, 'a', ['href', 'onClick'])
const ArtistImage = createComponent(__artistImg)
const ArtistInfo = createComponent(__artistInfo)

const Artists = ({
	artistImage,
	artistName,
	artistType,
	row,
	pullRight,
	imageWidth,
	marginBottom,
	clickable,
	onClick,
	isDesktop = false,
	showEditIcon = false,
	url = '',
}) => (
	<div>
		<Artist
			row={row}
			marginBottom={marginBottom}
			clickable={clickable}
			onClick={e => onClick(e)}
			isDesktop={isDesktop}
			href={clickable && url}
		>
			<ImageIconWrapper>
				<ArtistImage imageWidth={imageWidth} row={row}>
					<LazyImage
						src={artistImage}
						srcErr={noArtistImageUrl}
						tinySrc={noArtistImageUrl}
						alt={artistName}
					/>
				</ArtistImage>
				{showEditIcon && (
					<IconWrapper>
						<ArtistIcon glyph={Edit} width="8px" height="8px" />
					</IconWrapper>
				)}
			</ImageIconWrapper>
			<ArtistInfo pullRight={pullRight} isDesktop={isDesktop}>
				<Typography variant="subtitle2" color="darkGrey4" tag="div">
					{artistName}
				</Typography>
				<Typography variant="body2" color="darkGrey4" tag="div">
					{artistType}
				</Typography>
			</ArtistInfo>
		</Artist>
	</div>
)

Artists.defaultProps = {
	title: '',
	banner: '',
	artistName: '',
	artistType: '',
	clickable: false,
	onClick: () => {},
	showEditIcon: false,
}

export default Artists
